<template>
	<div>
		<div  class="flex step3" >
										<div class="flex" style="justify-content: center;align-items: center">
												<div>
													<div style="width: 81px;height: 73px;margin: 60px auto 40px" >
															<img v-if="status==1" src="@/assets/img/dataImport/zhuyi-2.png" style="width:100%" alt="" srcset="">
															<img v-if="status==2" src="@/assets/img/dataImport/tishi copy 2.png" style="width:100%" alt="" srcset="">
													</div>
													<div class="tishi" style="text-align: center">
														<h3  v-if="status==1">校验未通过</h3>
														<h3  v-if="status==2" style="color: #FF9F00;">校验未通过</h3>
														<p v-if="status==1" style="margin: 4px 0 50px;font-size: 12px;color: red;">导入共计100人，校验通过80人</p>
														<p v-if="status==2" style="margin: 4px 0 50px;font-size: 12px;color: #FF9F00;">导入共计100人，校验通过80人</p>
														<p class="p2">您可以通过  <font >导出</font> 错误结果文件，修改完成<font @click="changeStatus()">再次上传</font></p>
													</div>
												</div>
		
										</div>
										<div class="errorCon">
											<div>
												<h3><img src="@/assets/img/dataImport/tishi.png" alt="" /><span>提示</span></h3>
												<p>1.这是一条提示信息这是一条提示信息</p>
												<p>2.这是一条提示信息这是一条提示信息</p>
											</div>
											<div>
												<h3><img src="@/assets/img/dataImport/tishi copy.png" alt="" /><span>警告</span></h3>
												<p>1.这是一条提示信息这是一条提示信息</p>
												<p>2.这是一条提示信息这是一条提示信息</p>
											</div>
											<div>
												<h3><img src="@/assets/img/dataImport/guanbi-3 copy 19.png" alt="" /><span>错误</span></h3>
												<p>1.这是一条提示信息这是一条提示信息</p>
												<p>2.这是一条提示信息这是一条提示信息</p>
											</div>
										</div>
										
		</div>
		<div v-if="status==2" style="margin-top: 70px;padding-bottom: 24px;text-align:center;">
				<el-button type="primary" @click="next()">下一步</el-button>
		</div>
	</div>
    
              
      
</template>

<script>
  export default {
    name: "step3",
    props: {
       step: {
       	type: String,
       	default: '',
       }
    },
    data() {
      return {
				status:1,
      };
    },
    methods: {
				next(){
					this.$emit('update:step', 'step4')
				},
				changeStatus(){
					this.status = 2;
				}
    }
  };
</script>

<style scoped >
	.flex{
		display: flex;
	}
   .step3 > div{
   	width: 50%;
   }
   .step3{
   	padding: 36px 300px 100px;
		box-sizing: border-box;
   }
   .errorCon{
   	min-width:330px;
   	padding: 44px 50px;
   	background:rgba(255,237,237,1);
   	border-radius:4px;
   	box-sizing: border-box;
   }
   .errorCon>div{
   	margin-bottom: 18px;
   }
   .errorCon>div:nth-last-of-type(1){
   	margin-bottom: 0;
   }
   .errorCon>div h3{
   		font-size:13px;
   		font-family:PingFangSC-Medium,PingFang SC;
   		font-weight:500;
   		color:rgba(51,51,51,1);
   		line-height:18px;
   	}
		.errorCon>div h3 img,.errorCon>div h3 span{
			vertical-align: middle;
		}
		.errorCon>div h3 img{
			margin-right: 9px;
		}
   .errorCon>div p{
   	font-size:12px;
   	font-family:PingFangSC-Regular,PingFang SC;
   	font-weight:400;
   	color:rgba(102,102,102,1);
   	line-height:17px;
   	margin-top: 4px;
		padding-left: 23px;
   }
	 .tishi h3{
	 	font-size:15px;
	 	font-family:PingFangSC-Medium,PingFang SC;
	 	font-weight:500;
	 	color:rgba(255,0,0,1);
	 	line-height:21px;
	 }
	 .tishi .p2{
	 	font-size:13px;
	 	font-family:PingFangSC-Regular,PingFang SC;
	 	font-weight:400;
	 	color:rgba(51,51,51,1);
	 	line-height:18px;
	 }
	 .tishi .p2 font,.step4>div p font{
	 	color: #0EA5E5;
	 	padding: 0 4px;
	 	cursor: pointer;
	 }
</style>
